import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import 'react-circular-progressbar/dist/styles.css';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

import Icon from '../../../components/common/atom/Icon';
import { Flex } from '../../../components/common/atom/Layout';
import { Button } from '../../../components/common/atom/Button';
import { ImageDownloadGuide } from '../../../components/common/molecules/DownloadButton';

import ThemeStyle from '../../../lib/style/ThemeStyle';
import ChangingProgressProvider from './ChangingProgressProvider';

import * as api from '../../../lib/api/api';
import { ERROR_RETRY } from '../../../lib/Error';

const ClearfaceOrder = () => {
  /** cropper */
  const cropperRef = useRef(null);
  const [image, setImage] = useState(null);
  const [modifiedTargetImage, setModifiedTargetImage] = useState(null);
  const imageInput = useRef(null);
  const [circularProgressbar, setCircularProgressbar] = useState(false);
  const [complete, setComplete] = useState(false);
  const [resultImageUri, setResultImageUri] = useState(null);
  const [cropper, setCropper] = useState(null);

  const onChange = (e) => {
    const imageFile = e.target.files[0];

    if (!imageFile)
      return alert('사진 업로드에 실패했습니다. 다시 시도해주세요.');

    if (!imageFile.type.includes('image') || imageFile.type.includes('gif'))
      return alert('이미지 파일만 업로드 가능합니다.(png, jpeg등 / gif 제외)');

    let reader = new FileReader();
    reader.readAsDataURL(imageFile);
    reader.onload = () => {
      setImage(imageFile);
      setModifiedTargetImage(reader.result);
    };
    reader.onerror = () =>
      alert('파일 읽기에 실패했습니다. 다시 시도해주세요.');
  };

  /** cropper */
  const onCrop = () => {
    setCropper(cropperRef.current.cropper);
  };

  const onClickToRotate = () => {
    cropper && cropper.rotate(90);
  };

  /** get cropped image */
  const clearfaceError = () => {
    alert(ERROR_RETRY);
    setCircularProgressbar(false);
  };

  const doClearfaceReset = () => {
    setImage(null);
    setModifiedTargetImage(null);
    setCropper(null);
    complete && setComplete(false);
  };

  const doGetClearfaceOrderData = (id) => {
    api
      .getClearfaceOrder({ id })
      .then((response) => {
        setCircularProgressbar(false);
        setComplete(true);
        setResultImageUri(response.data.storageUri);
      })
      .catch(() => clearfaceError());
  };

  const doCreateClearfaceOrder = () => {
    if (!cropper)
      return alert('클리어페이스를 진행할 초음파 사진을 업로드 해주세요.');

    if (cropper.getCroppedCanvas().constructor !== HTMLCanvasElement)
      return alert('초음파 사진을 다시 올려 주세요.');

    cropper.getCroppedCanvas().toBlob((blob) => {
      let files = new FormData();
      files.append('files', image, image.name.split('.')[0]); // 원본
      files.append('files', blob, image.name.split('.')[0].concat('_cropped')); // 크롭이미지
      setCircularProgressbar(true);

      api
        .createClearfaceOrder({ files })
        .then((response) => {
          setTimeout(() => {
            doGetClearfaceOrderData(response.data.id);
          }, timer);
        })
        .catch(() => clearfaceError());
    });
  };

  // 제출 후 로딩
  if (circularProgressbar) {
    return (
      <Flex>
        <Area padding="20%">
          <ChangingProgressProvider
            values={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
          >
            {(percentage) => (
              <CircularProgressbar
                value={percentage}
                text={`${percentage}%`}
                styles={buildStyles({
                  textSize: '1.25rem',
                  textColor: ThemeStyle.color.orangePink,
                  pathColor: ThemeStyle.color.orangePink,
                })}
              />
            )}
          </ChangingProgressProvider>
        </Area>
      </Flex>
    );
  }

  // 로딩 완료 후 결과 페이지
  if (complete) {
    return (
      <Flex>
        <Area>
          <ImageBox src={resultImageUri} alt="결과" objectFit="contain" />
          <ImageDownloadGuide />
          <Flex width="100%" padding="0.625rem 0 0">
            <ClearfaceOrderFullWidthButton
              onClick={doClearfaceReset}
              backgroundColor={ThemeStyle.color.pinkishGrey}
            >
              다시 해보기
            </ClearfaceOrderFullWidthButton>
            <ClearfaceOrderFullWidthButton
              backgroundColor={ThemeStyle.color.orangePink}
            >
              <a href={googleFormsCF} target="_blank" rel="noopener noreferrer">
                설문조사 하러가기
              </a>
            </ClearfaceOrderFullWidthButton>
          </Flex>
        </Area>
      </Flex>
    );
  }

  return (
    <Flex>
      <Area>
        {/* {image ? (
          <>
            <Icon
              iconName="loop"
              size={60}
              onClick={onClickToRotate}
              style={{
                position: 'absolute',
                zIndex: 10,
                color: ThemeStyle.color.pinkishGrey,
                cursor: 'pointer',
              }}
            />
            <Cropper
              src={modifiedTargetImage}
              style={{ height: 320, width: '100%' }}
              ref={cropperRef}
              crop={onCrop}
              aspectRatio={1 / 1}
              guides={false}
              autoCropArea={0.7}
              viewMode={1}
              dragMode="move"
              cropBoxMovable={false}
              checkOrientation={false}
            />
          </>
        ) : (
          <>
            <input
              type="file"
              accept="image/png,image/jpeg"
              style={{ display: 'none' }}
              onChange={onChange}
              ref={imageInput}
            />
            <EmptyImageUploadBox onClick={() => imageInput.current.click()}>
              <Icon iconName="add" size={72} />
              초음파 사진 업로드하기
            </EmptyImageUploadBox>
          </>
        )} */}
        <Flex width="100%">
          <ClearfaceOrderFullWidthButton
            onClick={doClearfaceReset}
            backgroundColor={ThemeStyle.color.pinkishGrey}
          >
            다시 올리기
          </ClearfaceOrderFullWidthButton>
          <ClearfaceOrderFullWidthButton
            backgroundColor={ThemeStyle.color.pinkishGrey}
          >
            결과 보기
          </ClearfaceOrderFullWidthButton>
        </Flex>
      </Area>
    </Flex>
  );
};

export default React.memo(ClearfaceOrder);

const timer = 10000;
export const googleFormsCF =
  'https://docs.google.com/forms/d/e/1FAIpQLSeUcZ_a1o5UxFlS0KVPnVRgsh5mxcIEMtCcOHHW576ssuWfXw/viewform';

const Area = styled.div`
  width: 100%;
  margin-top: 0.625rem;

  display: flex;
  flex-direction: column;
  padding: ${(props) => props.padding};
`;

const EmptyImageUploadBox = styled(Flex)`
  min-height: 20rem;
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(88, 82, 105, 0.28);
  background-color: #f6f7fb;
  flex-direction: column;
  font-size: 18px;
  font-weight: bold;
  color: #4a4a4a;
  cursor: pointer;
`;

const ClearfaceOrderFullWidthButton = styled(Button)`
  width: ${(props) => props.width || '50%'};
  height: 3rem;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 0;
`;

const ImageBox = styled.img`
  object-fit: ${(props) => props.objectFit || 'cover'};
  height: 20rem;
  max-height: 20rem;
`;
